module.exports = __webpack_public_path__ + "static/media/controller.61af4a6b.png";